import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FloatingMenuComponent } from './floating-menu/floating-menu.component';
import { FloatingBannerComponent } from './floating-banner/floating-banner.component';
import { BannerMoveComponent } from './banner-move/banner-move.component';
import { LoadingComponent } from './loading/loading.component';

@NgModule({
  declarations: [
    FloatingMenuComponent,
    FloatingBannerComponent,
    BannerMoveComponent,
    LoadingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    FloatingMenuComponent,
    CommonModule,
    FormsModule,
    FloatingBannerComponent,
    BannerMoveComponent,
    LoadingComponent
  ]
})
export class SharedModule { }